<template>
  <van-cell-group title="说明">
  <van-cell title="这里是福利申请网站2.0,如有bug请报给责任编辑" />
  <van-cell title="请使用手机浏览器操作以获得最佳体验，iOS通过Safari添加到主屏幕功能获得APP的体验；安卓可以通过chrome浏览器进行安装" />
  <van-cell title="申请往期福利时，请联系责编私聊申请" />
  <van-cell title="系统将自动缓存您的作者名、联系QQ，在下一次申请时会自动填充，信息保存在浏览器缓存中，清除缓存则设置失效" />
</van-cell-group>
</template>
